import styles from '@components/components/CmsComponents/components/CmsInfobox/CmsInfobox.module.scss';
import Container from '@components/components/Container/Container';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  Content,
  Heading,
  Image,
  Link,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';

const BlogItem = ({
  headingLevel = 2,
  content,
  copyright,
  image,
  title,
  link,
}) => {
  const children = (
    <>
      {title && (
        <Heading as={getHeadingTag(headingLevel)} noSpacing size="h5">
          {title}
        </Heading>
      )}
      <div className={styles.contentWrapper}>
        {content && (
          <Content noSpacing size="md" withParser>
            {content}
          </Content>
        )}
        {link && (
          <Link
            className={styles.link}
            rel="noopener noreferrer"
            target={link.target}
            to={link.url}
          >
            {link.title}
          </Link>
        )}
      </div>
      {copyright && (
        <Content className={styles.copyright} noSpacing>
          {copyright}
        </Content>
      )}
    </>
  );

  return image ? (
    <div className={styles.infoBoxWithImage}>
      <Image
        alt={image.alt}
        className={styles.blogImage}
        src={image.src}
        srcSet={image.srcSet}
      />
      <div className={styles.contentWithImage}>{children}</div>
    </div>
  ) : (
    <Card className={styles.infoBoxWithoutImage} variant="elevated">
      <CardBody>{children}</CardBody>
    </Card>
  );
};

const CmsInfobox = props => (
  <Container size="lg">
    <BlogItem {...props} />
  </Container>
);

CmsInfobox.propTypes = {
  headingLevel: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.objectOf(
        PropTypes.shape({
          alt: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.string,
        }),
      ),
      link: PropTypes.objectOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
          target: PropTypes.string,
        }),
      ),
      content: PropTypes.string,
      title: PropTypes.string,
      copyright: PropTypes.string,
    }),
  ),
};
CmsInfobox.defaultProps = {
  items: [],
};

export default CmsInfobox;
